import React from 'react';
import factory from 'components/Icons/factory';

// Icons are built as 128x128 originals
export const Heart = factory(
  'Heart',
  <path d="M92.2 14c-7.2 0-14.6 2.6-20.6 7.8l-7.4 9.5-7.5-9.4c-6-5.2-13.1-7.8-20.6-7.8-7.2 0-14 2.6-20.1 7.8C2.7 34.7 2.7 54 15.9 66.6L64 114l48.2-47.3c13.1-12.6 13.1-32 0-44.5-6-5.5-13-8.2-20-8.2z" />
);

export default Heart;
